window.$ = jQuery;
window.jQuery = jQuery;

$.ajaxSetup({
    xhrFields: {
        withCredentials: true,
    },
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
    },
});

import './libs/sentry';
import './l10n';
import './src/tracker';
import './src/mobile/lazyload';
import './src/desktop/layout';
import './src/langSwitcher';

if (typeof appConfig.isOffice !== 'undefined' && appConfig.isOffice) {
    import('./libs/ckeditor').then(() => {
        import('./src/desktop/office');
    });
}

// Routes
const routeName = window.appConfig.currentRoute;

switch (routeName) {
    case 'main':
        import('./pages/desktop/index-page');
        break;
    case 'products.show':
        import('./pages/desktop/good');
        break;
    case 'contacts':
        import('./pages/desktop/contacts');
        break;
    case 'request.create':
        import('./pages/desktop/request');
        break;
    case 'reviews':
        import('./pages/desktop/reviews');
        break;
    case 'news.show':
    case 'faq.show':
    case 'articles.show':
        import('./src/articles');
        break;
    case 'basket':
        import('./pages/desktop/basket');

        if (typeof window.ORDER_PREORDER !== 'undefined' && window.ORDER_PREORDER) {
            import('./pages/preorder');
        }
        break;
    case 'order.contacts':
    case 'order.delivery':
        import('./pages/ordering');
        break;
    case 'account':
    case 'account.settings':
    case 'account.payments':
    case 'account.orders':
    case 'account.requests':
    case 'account.notifications':
    case 'account.comments':
    case 'account.partnership':
        import('./pages/desktop/cabinet');
        break;
    case 'account.spider':
        import('./pages/desktop/cabinet/spider');
        import('./src/validation');
        break;
    case 'account.motor':
        import('./pages/desktop/cabinet/motor');
        break;
    case 'account.module':
        import('./pages/desktop/cabinet/module');
        import('./src/validation');
        break;
    case 'favorites':
        import('./pages/desktop/favorites');
        break;
    case 'finder':
        import('./pages/finder');
        break;
    case 'contest':
        import('./pages/contest');
        break;
    case 'ideas_index':
    case 'ideas_index_popular':
        import('./pages/desktop/ideas');
        break;
    case 'order_finished':
        if (typeof window.ORDER_PREORDER !== 'undefined' && window.ORDER_PREORDER) {
            import('./pages/preorder');
        }
        break;
    case 'catalog.primary':
    case 'catalog.subcategory':
    case 'catalog.models':
        import('./pages/desktop/catalog');

        if (typeof window.APP_CONTEXT !== 'undefined' && window.APP_CONTEXT) {
            import('./app/app-client');
        }

        if (['catalog.models', 'catalog.primary'].indexOf(routeName) !== -1) {
            import('./pages/catalog-models');
        }
        break;
}
